module.exports = __webpack_public_path__ + "img/4.9e8cd16d.jpg";